export const getChartCustomizationsKey = (customizations: string[]) =>
  customizations.join('__');
